import { Injectable } from "@angular/core";
import { NmsWizardStepMapData } from "@nms-angular-toolkit/nms-wizard";
import { DwdmDiagramWizardConverterIntermediatesService } from "./dwdm-diagram-wizard-converter-intermediates.service";
import { DwdmDiagramWizardConverterLinksService } from "./dwdm-diagram-wizard-converter-links.service";
import { CircuitDiagram, EndpointDeviceElement, EndpointType } from "../../diagram/models/diagram.models";
import { IntermediatesStepModel } from "../steps/3-intermediates/intermediates-step.model";
import { LinksStepModel } from "../steps/4-links/links-step.model";
import { DwdmDiagramAbstractConverter } from "../../diagram/converter/dwdm-diagram-abstract-converter";
import { DwdmDiagramWizardConverterEndService } from "./dwdm-diagram-wizard-converter-end.service";
import { CircuitToDiagramData } from "../../diagram/converter/dwdm-diagram-converter.models";

/**
 * Implementação de {@link DwdmDiagramAbstractConverter} para o Wizard de criação de circuitos DWDM.
 * Converte {@link NmsWizardStepMapData} em {@link CircuitDiagram}.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramWizardConverterService extends DwdmDiagramAbstractConverter {

    constructor(private readonly endConverterService: DwdmDiagramWizardConverterEndService,
            private readonly intermediatesConverterService: DwdmDiagramWizardConverterIntermediatesService,
            private readonly linksConverterService: DwdmDiagramWizardConverterLinksService) {
        super();
    }

    public convert(stepModel: NmsWizardStepMapData, isOnLinkStep: boolean = false, isOnOscStep: boolean = false): CircuitDiagram {
        const circuitDiagram: CircuitDiagram = {} as CircuitDiagram;
        const intermediatesModel = stepModel["IntermediatesStepModel"] as IntermediatesStepModel;
        const linksModel = stepModel["LinksStepModel"] as LinksStepModel;
        const circuitToDiagramData: CircuitToDiagramData = {circuitModels: stepModel, isOnLinkStep, isOnOscStep};

        const {aEnd, zEnd, intermediates, links} = this.convertModels(circuitToDiagramData);

        const aEndIdentifier = this.endConverterService.convert(aEnd);
        circuitDiagram.aEnd = aEndIdentifier.endpoint as EndpointDeviceElement<EndpointType.A_END>;

        const zEndIdentifier = this.endConverterService.convert(zEnd);
        circuitDiagram.zEnd = zEndIdentifier.endpoint as EndpointDeviceElement<EndpointType.Z_END>;

        const intermediatesIdentifier = this.intermediatesConverterService.convert(intermediates)
        circuitDiagram.intermediates = intermediatesIdentifier.map(intermediateIdentifier => intermediateIdentifier.intermediate);

        circuitDiagram.links = this.linksConverterService.convert(links, aEndIdentifier, zEndIdentifier, intermediatesIdentifier);

        circuitDiagram.showExternalLinks = this.shouldShowExternalLinks(intermediatesModel, linksModel);

        return circuitDiagram;
    }

    /**
     * Num geral os links externos (links que ligam equipamentos) devem ser exibidos,
     * mas caso o toggle do step de intermediários estiver ativo e não houver algum link
     * configurado, então os links externos não devem ser exibidos.
     */
    private shouldShowExternalLinks(intermediatesModel: IntermediatesStepModel, linksModel: LinksStepModel): boolean {
        const hasConfiguredLinks = !!linksModel?.links;

        return hasConfiguredLinks || !intermediatesModel?.useIntermediateDevices;
    }

}
